import { PlusCircleIcon } from "@heroicons/react/16/solid";

const ButtonAddFileComponent = ({ title, handleAdd }) => {

    return (
        <>
            <button
                className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg h-[36px] hover:bg-[#6f9239] transition-all duration-500 ease-linear transform hover:rotate-180 active:rotate-360"
                onClick={handleAdd}
                title={title}
            >
                <PlusCircleIcon width={16} height={16} />
            </button>
        </>
    );
}

export default ButtonAddFileComponent;